import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    produits:Array<{titre:string,url:string}>=[
        {
            titre:'Mattress weaving ticking jacquard Fabric',
            url:'mattress-ticking'
        },
        {
            titre:'Mattress Knitting ticking jacquard Fabric',
            url:'stretch-fabrics'
        },
        {
            titre:'Tarpaulin fabric',
            url:'tarpaulin-fabric'
        },
        {
            titre:'Decorative tent Fabric',
            url:'decorative-fabric-tent'
        },
        {
            titre:'Technical Fabric',
            url:'technical-fabric'
        }
    ];
  constructor() { }

  ngOnInit(): void {
  }

}
